import { isGlovv, isKyolook, isOneulook } from '../domains/domains'

export const getServiceName = () => {

  const locale = process.env.LOCALE;

  // ko
  if (isGlovv()) {
    switch(locale){
      case 'ko':
        return '글로브'
      case 'ja':
        return 'GLOVV'
    }
  } else if (isOneulook()) {
    switch(locale){
      case 'ko':
        return '오늘룩'
      case 'ja':
        return 'ONEULOOK'
    }
  }


  // ja
  if (isKyolook()) {
    switch(locale){
      case 'ko':
        return '쿄룩'
      case 'ja':
        return 'KYOLOOK'
    }
  }
  
  return locale === 'ko' ? '오늘룩' : 'ONEULOOK'
}

export const getServiceUrl = () => {

  const locale = process.env.LOCALE;

  // ko
  if (isGlovv()) {
    switch(locale){
      case 'ko':
        return '글로브'
      case 'ja':
        return 'GLOVV'
    }
  } else if (isOneulook()) {
    switch(locale){
      case 'ko':
        return '오늘룩'
      case 'ja':
        return 'ONEULOOK'
    }
  }


  // ja
  if (isKyolook()) {
    switch(locale){
      case 'ko':
        return '쿄룩'
      case 'ja':
        return 'KYOLOOK'
    }
  }
  
  return locale === 'ko' ? '오늘룩' : 'ONEULOOK'
}


export const getServiceNameEn = (isUppercase = false) => {
  // ko
  if (isGlovv()) {
    switch(isUppercase){
      case true:
        return 'GLOVV'
      case false:
        return 'Glovv'
    }
  } else if (isOneulook()) {
    switch(isUppercase){
      case true:
        return 'ONEULOOK'
      case false:
        return 'Oneulook'
    }
  }


  // ja
  if (isKyolook()) {
    switch(isUppercase){
      case true:
        return 'KYOLOOK'
      case false:
        return 'Kyolook'
    }
  }
  
  return isUppercase ? 'ONEULOOK' : 'Oneulook'
}
